import React, { useState, useEffect } from "react";
import axios from "axios";
import API_ENDPOINT from "../wm.api.service";
import "./login.css";
import Wmbutton from "../ui-components/wm-button/Wm.button";
import Wminput from "../ui-components/wm-form-components/input/Wm.input";
import Cookies from "universal-cookie";
import { useHistory } from "react-router-dom";
import { encode } from "base-64";
import ReCAPTCHA from "react-google-recaptcha";
import { Container, Row, Col } from "react-bootstrap";
import { useGoogleLogin } from "react-google-login";
import CircularProgress from "@material-ui/core/CircularProgress";
// IMAGE
import google from "../assets/images/google-icon.svg";
import logo from "../assets/images/logo2.svg";
import eye from "../assets/images/eye.png";
import hide from "../assets/images/noteye.png";
import { authAction } from "./authActions";
import { PASSWORD_LENGTH } from "../config";
const cookies = new Cookies();
function Signup() {
  const history = useHistory();
  var token = cookies.get("wmtoken");
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  const redirect = urlParams.get("redirect");
  const [isGoogleLogin, setIsGoogleLogin] = useState(false);
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [institution, setInstitution] = useState("");
  const [isGettingRegister, setIsGettingRegister] = useState(false);
  // const [googledata, setGoogleData] = useState("");
  const [isConfirmPassword, setIsConfirmPassword] = useState(false);
  const [service, setService] = useState("");
  const [redirectURL, setRedirectURL] = useState("");
  const [action, setAction] = useState("");
  const [aData, setAdata] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  useEffect(() => {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    setService(urlParams.get("service"));
    setRedirectURL(urlParams.get("metaURL"));
    setAction(urlParams.get("action"));
    setAdata(urlParams.get("aData"));
  });
  const [captaToken, setCaptaToken] = useState("");
  const [errorMes, setErrorMes] = useState("");
  function onChange(value) {
    setCaptaToken(value);
    setErrorMes("");
  }
  const signUp = (e) => {
    e.preventDefault();
    if (captaToken) {
      setIsGettingRegister(true);
      var fd = new FormData();
      fd.append("first_name", firstName);
      fd.append("last_name", lastName);
      fd.append("email", email);
      fd.append("password", password);
      fd.append("password_confirm", confirmPassword);
      fd.append("institution", institution);
      if (password !== confirmPassword) {
        setIsConfirmPassword(true);
        setIsGettingRegister(false);
      } else {
        axios({
          method: "POST",
          url: `${API_ENDPOINT.apiURL}Authentication/registerUser`,
          data: fd,
        })
          .then((response) => {
            if (
              response.data.message === "registration success" ||
              response.data.message === "Login Success"
            ) {
              setIsGettingRegister(false);
              var encodeToken = encode(response.data.token);
              cookies.set("wmtoken", encodeToken, {
                domain: ".wisemonkeys.info",
              });
              // cookies.set("wmtoken", encodeToken, { path: "/" });
              if (redirect) {
                return window.location.assign(redirect);
              }
              if (service === null) {
                window.location.assign("/user");
              } else {
                authAction(encodeToken, service);
              }
            }
          })
          .catch((err) => {
            const { message } = err.response.data;
            console.log(message.replace(/(\r\n|\n|\r)/gm, ""));
            if (
              message.replace(/(\r\n|\n|\r)/gm, "") ===
              "The email field must contain a unique value."
            ) {
              setErrorMessage("This email address has been used already!");
            }
            setIsGettingRegister(false);
          });
      }
    } else {
      setErrorMes("Please Solve The reCaptcha");
    }
  };
  useEffect(() => {
    if (isConfirmPassword) {
      setTimeout(() => {
        setIsConfirmPassword(false);
      }, 3000);
    }
  }, [isConfirmPassword]);
  // GOOGLE SIGN IN
  const successGoogleLogin = (token, id, email, firstname, lastname, photo) => {
    var fd = new FormData();
    fd.append("idToken", token);
    fd.append("id", id);
    fd.append("email", email);
    fd.append("photo", photo);
    fd.append("first_name", firstname);
    fd.append("last_name", lastname);
    fd.append("platform", "web");
    axios({
      method: "POST",
      url: `${API_ENDPOINT.apiURL}Authentication/loginGoogle`,
      data: fd,
    })
      .then((response) => {
        if (
          response.data.message === "Registration Success" ||
          response.data.message === "Login Success"
        ) {
          var encodeToken = encode(response.data.token);
          cookies.set("wmtoken", encodeToken, { domain: ".wisemonkeys.info" });
          // cookies.set("wmtoken", encodeToken, { path: "/" });
          if (redirect) {
            return window.location.assign(redirect);
          }
          if (service === null) {
            window.location.assign("/user");
          } else {
            authAction(encodeToken, service);
          }
        }
      })
      .catch((err) => {
        console.log(err.response);
      });
  };

  // Password Word Count
  const [countBool, setCountBool] = useState(false);
  const passCount = (val) => {
    if (val.length < PASSWORD_LENGTH) {
      setCountBool(true);
    }
    if (val.length >= PASSWORD_LENGTH) {
      setCountBool(false);
    }
  };
  const userPage = () => {
    history.replace("/user");
  };
  // Password Toggle
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const clientId =
    "978867783991-j1c9tn3b7btdp4nc2jo4o49q2mo9qe4b.apps.googleusercontent.com";
  const onFailure = (res) => {
    setIsGoogleLogin(false);
    if (res.details === "Cookies are not enabled in current environment.") {
      alert(
        'Cookies are not enabled, Please go to settings and enable "Allow all cookies"'
      );
    }
  };
  const onSuccess = (res) => {
    setIsGoogleLogin(true);
    successGoogleLogin(
      res.tokenId,
      res.googleId,
      res.profileObj.email,
      res.profileObj.givenName,
      res.profileObj.familyName,
      res.profileObj.imageUrl
    );
  };
  const { signIn } = useGoogleLogin({
    onSuccess,
    onFailure,
    clientId,
    cookiePolicy: "single_host_origin",
  });
  return (
    <>
      <div className="loginBg signupBG_img py-5">
        <div className="signup px-3">
          <div className="flex justify-center mb-4">
            <img src={logo} alt="logo" className="w-48" />
          </div>
          <div className="login_container">
            <span className="mb-3 font-semibold block text-4xl login-fs px-2">
              Sign up
            </span>
            <form>
              <Container>
                <Row>
                  <Col md={6}>
                    <div className="flex flex-col mb-4">
                      <label htmlFor="First name" className="text-sm">
                        First Name
                      </label>
                      <Wminput
                        type="text"
                        name="firstName"
                        onChange={(e) => setFirstName(e.target.value)}
                      />
                    </div>
                  </Col>
                  <Col md={6}>
                    <div className="flex flex-col mb-4">
                      <label htmlFor="Last name" className="text-sm">
                        {" "}
                        Last Name
                      </label>
                      <Wminput
                        type="text"
                        name="lastName"
                        onChange={(e) => setLastName(e.target.value)}
                      />
                    </div>
                  </Col>
                  <Col md={12}>
                    <div className="flex flex-col mb-4">
                      <label htmlFor="Email" className="text-sm">
                        Email
                      </label>
                      <Wminput
                        type="email"
                        name="email"
                        onChange={(e) => setEmail(e.target.value)}
                      />
                    </div>
                    {errorMessage && (
                      <span className="text-red-600 text-xs text-center block mb-4">
                        {errorMessage}
                      </span>
                    )}
                  </Col>
                  <Col md={12}>
                    <div className="flex flex-col mb-4 relative">
                      <label htmlFor="First name" className="text-sm">
                        Password({PASSWORD_LENGTH} or more characters)
                      </label>
                      <div className="flex border-b border-gray-300 border-solid">
                        <Wminput
                          type={`${showPassword ? "text" : "password"}`}
                          name="password_login"
                          className="border-0 flex-1"
                          onChange={(e) => {
                            setPassword(e.target.value);
                            passCount(e.target.value);
                          }}
                        />
                        <img
                          src={showPassword ? eye : hide}
                          alt="eye"
                          className="w-7 cursor-pointer"
                          style={{ filter: "opacity(0.5)" }}
                          onClick={() => setShowPassword(!showPassword)}
                        />
                      </div>
                    </div>
                    <div>
                      {countBool && (
                        <div className="text-center">
                          <span className="text-red-600 text-xs">
                            {" "}
                            Password Should be more than {PASSWORD_LENGTH}{" "}
                            characters
                          </span>
                        </div>
                      )}
                      {errorMes && (
                        <span className="text-red-600 text-xs">{errorMes}</span>
                      )}
                    </div>
                  </Col>
                  <Col md={12}>
                    <div className="flex flex-col mb-4 relative">
                      <label htmlFor="First name" className="text-sm">
                        {" "}
                        Confirm Password
                      </label>
                      <div className="flex border-b border-gray-300 border-solid">
                        <Wminput
                          type={`${showPassword ? "text" : "password"}`}
                          name="confirmPasswordRegister"
                          className="border-0 flex-1"
                          onChange={(e) => {
                            setConfirmPassword(e.target.value);
                          }}
                        />
                        <img
                          src={showConfirmPassword ? eye : hide}
                          alt="eye"
                          className="w-7 cursor-pointer"
                          style={{ filter: "opacity(0.5)" }}
                          onClick={() =>
                            setShowConfirmPassword(!showConfirmPassword)
                          }
                        />
                      </div>
                    </div>
                    <div>
                      {isConfirmPassword && (
                        <div className="text-center">
                          <span className="text-red-600 text-xs">
                            Confirm Password Does not Match
                          </span>
                        </div>
                      )}
                    </div>
                  </Col>
                  <Col md={12}>
                    <div className="text-center w-full flex items-center justify-center">
                      <ReCAPTCHA
                        sitekey="6LerMHIcAAAAAOUy6oJG2xt0SDTuSVoNbPX4K4w3"
                        onChange={onChange}
                      />
                    </div>
                  </Col>
                  <Col md={12}>
                    <div className="aggrement_content my-3">
                      <small>
                        By clicking Agree & Join, you agree to the Wisemonkeys{" "}
                        <a href="http://">User Agreement</a>,{" "}
                        <a href="http://">Privacy Policy</a>, and{" "}
                        <a href="http://">Cookie Policy</a>.
                      </small>
                    </div>
                  </Col>
                  <Col md={12}>
                    <div className="wm-form-group flex mb-3">
                      <Wmbutton
                        className="h-10 login-btn"
                        label={`${
                          isGettingRegister ? "Loading..." : "Agree & Join"
                        }`}
                        type="submit"
                        color="primary"
                        onClick={(e) => signUp(e)}
                        disable={isGettingRegister}
                      />
                    </div>
                  </Col>
                  <Col md={12}>
                    <div className="divider-wrapper text-center">
                      <p className="divider relative">or</p>
                    </div>
                  </Col>
                  <Col md={12}>
                    <div className="wm-form-group flex mb-4">
                      <Wmbutton
                        className="h-10 login-btn flex justify-center items-center"
                        label={
                          isGoogleLogin ? (
                            <CircularProgress className="loader_size_xsm" />
                          ) : (
                            "Join with Google"
                          )
                        }
                        type="submit"
                        bordered
                        color="primary"
                        onClick={signIn}
                      >
                        <img
                          src={google}
                          alt="google"
                          className="w-4 mr-2 google_ico"
                        />
                      </Wmbutton>
                    </div>
                  </Col>
                  <Col md={12}>
                    <div className="already_in_out">
                      <p className="mr-2 fs-13">Already a member?</p>
                      <a
                        href={`/login${localStorage.getItem("wm_actionURL")}`}
                        className="fs-13"
                      >
                        Login
                      </a>
                    </div>
                  </Col>
                </Row>
              </Container>
            </form>
          </div>
        </div>
      </div>
    </>
  );
}

export default Signup;
